export enum SmsSettingsTabsEnum {
  MARKETING = 'marketing',
  REMINDER = 'reminder',
  REPORT = 'report',
}

